<template>
  <span>Se actualizo con Exito.</span>
</template>

<script>
  export default {
    name: 'notification-template'
  }
</script>
